import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { SSQTextInput } from "src/components/SSQ/FormFields/SSQTextInput";
import { deserializeValueProperty, serializeValueProperty } from "src/context/Property/PropertyValueSerializer";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { CommonPropertyProps } from "./_common";
import { ScoreService } from "src/context/EntityBasedScore/ScoreService";

type TextProps = CommonPropertyProps;
export const Text = (props: TextProps) => {
    const { t } = useTranslation();
    const { selectedScore } = useActionsContext();

    const { property, updatePropertyValue, isLocked = false, shouldShowSubscore = false, comparisonProperty } = props;
    const values = deserializeValueProperty(property);

    const [value, setValue] = useState(values.value);
    const hasBeenChanged = useRef<boolean>(false);

    const { hint, readonly = false } = property.property;
    const tooltipText = hint ? <div dangerouslySetInnerHTML={{ __html: hint }} /> : undefined;
    const defaultValueText = readonly ? t("Cette valeur est en lecture seule") : t("Valeur par défaut :");

    const onCalculate = (newValue: string) => {
        if (hasBeenChanged.current === false) return;
        hasBeenChanged.current = false;
        const sanitizedValue = serializeValueProperty(newValue);
        updatePropertyValue({ serializedString: sanitizedValue.value, calculationType: "action" });
    };

    const comparedTo = comparisonProperty?.score?.value ?? null;
    const currentScore = property.score?.value ?? null;
    const _scoreDiff = ScoreService.substractScore(comparedTo, currentScore);
    const scoreDiff = ScoreService.normalizeScore(_scoreDiff, selectedScore.precision).value;
    const score = shouldShowSubscore && scoreDiff !== 0 ? scoreDiff : null;
    return (
        <SSQTextInput
            onCalculate={onCalculate}
            score={{
                score,
                unit: selectedScore.unit,
                comparisonValues: {
                    currentValue: currentScore,
                    comparedTo,
                    improvement: selectedScore.improvement,
                },
            }}
            tooltipText={tooltipText}
            defaultOption={
                values.defaultValue === undefined ?
                    undefined
                :   {
                        value: values.defaultValue,
                        label: defaultValueText,
                    }
            }
            value={value}
            onChange={(newValue) => {
                hasBeenChanged.current = true;
                setValue(newValue);
            }}
            unit={property.unit}
            disabled={readonly || property.isGenericValue || isLocked}
            ExtraInputProps={{
                onFocus: (e) => {
                    const isFocusDirect = !e.relatedTarget;
                    if (!isFocusDirect) {
                        return;
                    }
                },
            }}
        />
    );
};
